<template>
    <v-dialog v-model="getCheckinOptionViewer" persistent width="55%">
        <v-card>
            <v-card-title class="d-flex align-center justify-center text-h5">Do you have a Lawyer or Public Defender to represent
                you?</v-card-title>
            <v-card-actions class="d-flex align-center justify-center pa-0 ma-0">
                <v-card @click="sendToCourtroom()" color="primary" class="white--text pa-4 d-flex align-center justify-center my-3" width="80%">Yes</v-card>
            </v-card-actions>
            <v-card-actions class="d-flex align-center justify-center pa-0 ma-0">
                <v-card @click="navigateToJano()" color="primary" class="white--text pa-4 d-flex align-center justify-center mb-4" width="80%">No</v-card>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: "checkinOptionViewer",
    computed: {
        ...mapGetters(["getCheckinOptionViewer"])
    },
    methods: {
        sendToCourtroom() {
            // av
            this.$store.dispatch('avatarSpeak', "You are already checked in. Please proceed to the courtroom and look to your attorney for further instructions.")
            this.$store.commit("setCheckinOptionViewer", false)
        },
        navigateToJano() {
            this.$store.commit("setCheckinOptionViewer", false)
            window.open("http://172.17.154.35/cm-checkin.html", '_blank');
        }
    }
}
</script>